import { axiosInstance } from '~/common/utils/api.util';

import type { ApiResponse } from '~/common/types/api.type';
import type { RemotePcAgent } from '~/features/remote-pc-agent/types/remote-pc-agent.type';

/**
 * Store IP 상세 조회
 * @description 특정 Store IP의 상세 정보를 조회합니다
 * @endpoint GET /admin/remote-pc-agents/{id}
 * @param id - Store IP ID
 * @returns Store IP 상세 정보
 */
export function getRemotePcAgentApi(id: number) {
  return axiosInstance.get<ApiResponse<RemotePcAgent>>(`/admin/remote-pc-agents/${id}`);
}
